<template>
  <div
    v-show="ageRestrictions && ageRestrictions.length > 0"
    class="capacity-rules"
  >
    <p v-for="(group, index) in ageRestrictions" :key="index" class="group">
      <translate v-if="index != 0 && ageRestrictions.length > 1">
        or
      </translate>
      <span class="restriction-group"
        ><span
          v-for="(restriction, spanIndex) in group"
          :key="spanIndex"
          class="restriction"
          ><template v-if="restriction.amount"
            ><translate
              v-if="restriction.age_type_id === 'people-at-most'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# person maximum} other{# people
              maximum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'adults-at-most'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# adult maximum} other{# adults
              maximum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'children-at-most'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# child maximum} other{# children
              maximum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'infants-at-most'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# infant maximum} other{# infants
              maximum}}</translate
            ><translate
              v-else-if="
                restriction.age_type_id === 'children-or-infants-at-most'
              "
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# child or infant maximum} other{# children
              or infants maximum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'people-at-least'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# person minimum} other{# people
              minimum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'adults-at-least'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# adult minimum} other{# adults
              minimum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'children-at-least'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# child minimum} other{# children
              minimum}}</translate
            ><translate
              v-else-if="restriction.age_type_id === 'infants-at-least'"
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# infant minimum} other{# infants
              minimum}}</translate
            ><translate
              v-else-if="
                restriction.age_type_id === 'children-or-infants-at-least'
              "
              :tt="{ amount: restriction.amount }"
              >{amount, plural, one{# child or infant minimum} other{# children
              or infants minimum}}</translate
            ></template
          ><template v-else
            ><translate v-if="restriction.age_type_id === 'people-at-most'"
              >Unlimited people</translate
            ><translate v-else-if="restriction.age_type_id === 'adults-at-most'"
              >Unlimited adults</translate
            ><translate
              v-else-if="restriction.age_type_id === 'children-at-most'"
              >Unlimited children</translate
            ><translate
              v-else-if="restriction.age_type_id === 'infants-at-most'"
              >Unlimited infants</translate
            ><translate
              v-else-if="
                restriction.age_type_id === 'children-or-infants-at-most'
              "
              >Unlimited children or infants</translate
            > </template
          ><template v-if="spanIndex != group.length - 1">, </template>
        </span>
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import { AgeRestrictions } from '~/apps/campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CapacityRules extends Vue {
  @Prop()
  ageRestrictions: AgeRestrictions
}

export default toNative(CapacityRules)
</script>
<style scoped>
.group {
  align-items: center;
  color: var(--colour-text);
  column-gap: 0.5ch;
  display: flex;
  font-size: var(--small) !important;
  justify-content: flex-start;
  line-height: 1.1;
  margin-top: 0.8em;
}

p:first-of-type {
  margin-top: 1.8em;
}

p + p {
  margin: 0;
}

.restriction-group {
  padding: 0.2em 0.4em;
  border-radius: 0.5em;
  border: 1px solid var(--colour-page-background);
}

.restriction {
  display: contents;
}
</style>
